import React, { useEffect, useState } from "react";
import mixpanel from "mixpanel-browser";
import ContentContainer from "../../templates/content-container/contentContainer";
import TrackShipmentState from "../../slices/track-shipment/TrackShipmentState";
import { useDispatch, useSelector } from "react-redux";
import { searchShipments, trackShipmentSelector } from "../../slices/track-shipment/trackShipmentSlice";
import ContentContainerToolbar from "../../ui-components/molecules/content-container-toolbar/contentContainerToolbar";
import FiltersToggle from "../../ui-components/filters-toggle/filtersToggle";
import TrackingFilter from "../shipments/tracking/tracking-filter/trackingFilter";
import Table from "../../ui-components/table/table";
import XGSErrorMessage from "../../ui-components/error-message/errorMessage";
import getAppointmentSummaryColumns from "./appointmentSummaryColumns";
import { CreateAppointment } from "./createAppointment";
import AppointmentOuterResultBlock from "./appointmentOuterResultBlock";
import { PAGE_IDS } from "../../app/data/common/pageIds";

import "./appointmentSummary.scss";
import { userSelector } from "slices/user/userSlice";

export const AppointmentSummary = () => {
  const userState = useSelector(userSelector);

  useEffect(() => {
    mixpanel.track("page_viewed", { page: "appointments" });
  }, [userState.activeTerminal?.id]);

  const trackShipmentState: TrackShipmentState = useSelector(trackShipmentSelector);

  const [selectedProbill, setSelectedProbill] = useState<number | null>(null);
  const dispatch = useDispatch();

  const onInfiniteScroll = () => {
    dispatch(searchShipments(trackShipmentState.request, true));
  };

  return (
    <ContentContainer
      className="xgs-list xgs-list--full-width"     
      titleComponent={
        <ContentContainerToolbar pageId={PAGE_IDS.APPOINTMENTS}  title="Appointments">
          <FiltersToggle />
        </ContentContainerToolbar>
      }
      header={
        <TrackingFilter source="APPOINTMENTS"/>
      }
      mods={{ "full-width": true }}
    >
      <div className="xgs-appointment-summary">
        {!trackShipmentState.loadingFailed && (
          <>
            <Table
              isLoading={trackShipmentState.loading}
              columns={getAppointmentSummaryColumns()}
              onRowClicked={(props: any) => setSelectedProbill(props.invoice.invoiceNumber)}
              cursorPointer
              data={trackShipmentState.shipments}
              infiniteScroll={true}
              infiniteScrollLoading={trackShipmentState.loadingPortion}
              highlightRow={!!selectedProbill ? trackShipmentState.shipments.findIndex((shipment) => shipment.invoice.invoiceNumber === selectedProbill) : null}
              infiniteScrollHasNext={!trackShipmentState.loadedAll}
              onInfiniteScroll={onInfiniteScroll}
              minTableHeight={420}
              rowHeight={64}                  
              responsive={true}
              maxTableWidth={1420}
              noResultsComponent={
                <>
                  {(trackShipmentState.requestResponseCode === 204 && !!trackShipmentState.request.trackingNumber && trackShipmentState.request.trackingNumber.length === 1)
                  // @ts-ignore-next-line
                    ? <AppointmentOuterResultBlock onClickView={() => setSelectedProbill(trackShipmentState.request.trackingNumber[0]!)} probillNumber={trackShipmentState.request.trackingNumber[0]} />
                    : "No results found"
                  }
                </>
              }
            />
          </>
        )}
        {trackShipmentState.loadingFailed && (
          <XGSErrorMessage>{trackShipmentState.error || "Error while obtaining the list of shipments"}</XGSErrorMessage>
        )}
      </div>
      {selectedProbill !== null && (
        <CreateAppointment
          onClose={() => setSelectedProbill(null)}
          probillNumber={selectedProbill}
        />
      )}
    </ContentContainer>
  );
}